module.exports = __webpack_public_path__ + "media/images/tl/banner/ko-2-dark-7583cfaf712d9c01e347db72790c5308.jpg";